(function () {
  var VAT_MODE_KEY = 'hardlife_vat_mode';
  var DEFAULT_MODE = 'ex';

  function getVatMode() {
    return localStorage.getItem(VAT_MODE_KEY) || DEFAULT_MODE;
  }

  function setVatMode(mode) {
    localStorage.setItem(VAT_MODE_KEY, mode);
  }

  function formatMoneyFromCents(cents, currencyCode) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currencyCode || 'GBP'
      }).format(amount);
    } catch (e) {
      return '£' + amount.toFixed(2);
    }
  }

  function updatePriceContainer(container, mode) {
    var vatRate = parseFloat(container.dataset.vatRate || '0.2');
    var exPrice = parseInt(container.dataset.priceEx || '0', 10);
    var exCompareAt = parseInt(container.dataset.compareAtEx || '0', 10);
    var currencyCode = document.documentElement.getAttribute('data-shop-currency') || 'GBP';

    var displayPrice = exPrice;
    var displayCompareAt = exCompareAt;
    var labelText = 'Ex VAT';

    if (mode === 'inc') {
      displayPrice = Math.round(exPrice * (1 + vatRate));
      displayCompareAt = exCompareAt > 0 ? Math.round(exCompareAt * (1 + vatRate)) : 0;
      labelText = 'Inc VAT';
    }

    container.querySelectorAll('.js-vat-price').forEach(function (el) {
      el.textContent = formatMoneyFromCents(displayPrice, currencyCode);
    });

    container.querySelectorAll('.js-vat-compare-at').forEach(function (el) {
      if (displayCompareAt > 0) {
        el.textContent = formatMoneyFromCents(displayCompareAt, currencyCode);
      }
    });

    container.querySelectorAll('.js-vat-label').forEach(function (el) {
      el.innerHTML = '<span class="sup">' + labelText + '</span>';
    });
  }

  function updateAllPrices(mode) {
    document.querySelectorAll('.price-container-vat').forEach(function (container) {
      updatePriceContainer(container, mode);
    });

    document.querySelectorAll('.vat-toggle-switch__input').forEach(function (input) {
      input.checked = (mode === 'inc');
    });
  }

  function bindVatToggleSwitches() {
    document.querySelectorAll('.vat-toggle-switch__input').forEach(function (input) {
      if (input.dataset.vatBound === 'true') return;

      input.addEventListener('change', function () {
        var mode = input.checked ? 'inc' : 'ex';
        setVatMode(mode);
        updateAllPrices(mode);
      });

      input.dataset.vatBound = 'true';
    });
  }

  function initVatToggle() {
    bindVatToggleSwitches();
    updateAllPrices(getVatMode());
  }

  document.addEventListener('DOMContentLoaded', initVatToggle);
  document.addEventListener('shopify:section:load', initVatToggle);
  document.addEventListener('shopify:section:reorder', initVatToggle);
  document.addEventListener('shopify:section:select', initVatToggle);

  document.addEventListener('change', function () {
    setTimeout(function () {
      initVatToggle();
    }, 150);
  });
})();